import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllHotelSearchData } from '../../services/hotel/hotelServices';

// Async thunk for fetching hotel data
export const fetchAllHotelList = createAsyncThunk(
    'hotelData/fetchAllHotelList',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getAllHotelSearchData(payload);
            return response?.data; 
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchAllHotelPriceList = createAsyncThunk(
    'hotelData/fetchAllHotelPriceList',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getAllHotelSearchData(payload);
            return response?.data; 
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const hotelsListSlice = createSlice({
    name: 'hotelData',
    initialState: {
        allHotelList: null,
        loading: false,
        error: null,
        isPriceLoaded: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllHotelList.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllHotelList.fulfilled, (state, action) => {
                state.allHotelList = action.payload; 
                state.loading = false;
                state.isPriceLoaded = action.payload.db==true?false:true
            })
            .addCase(fetchAllHotelPriceList.fulfilled, (state, action) => {
                const hotels = action.payload?.hotels || [];
                if (!state.allHotelList?.hotels) return;
                state.allHotelList.hotels = state.allHotelList.hotels.map((hotel) => {
                    const matchedHotel = hotels.find(
                        (p) => p.HotelCode === hotel.HotelCode
                      );
                    if (matchedHotel) {
                        return {
                            ...hotel,
                            pops: matchedHotel.pops,
                            traceId: matchedHotel.traceId,
                            resultIndex: matchedHotel.resultIndex
                        };
                    }
                   return null;
                }).filter(Boolean);
                state.isPriceLoaded = true;
            })
            .addCase(fetchAllHotelList.rejected, (state, action) => {
                state.error = action.error.message;
                state.loading = false;
            });
    },
});

export default hotelsListSlice.reducer;